import { QuestionExplanation } from '../../types'

export const SPELLINGWW_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'WW-L1-001': {
    id: 'WW-L1-001',
    explanation:
      'De hond = hij/zij. Bij hij/zij schrijf je: grondwoord + t. Blaf + t = blaft.',
    distractorExplanations: {
      '1': 'Je hoort een d, maar schrijf gewoon een t. Bij hij/zij altijd: grondwoord + t.',
      '2': 'Je schreef "blafdt". Dat is te veel! Het is gewoon "blaft" (alleen een t).',
      '3': 'Dit is de ik-vorm (ik blaf). Maar "de hond" = hij.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Grondwoord + t',
        content:
          'Bij hij, zij, het schrijf je: grondwoord + t. De hond = hij → blaf + t = blaft',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-002': {
    id: 'WW-L1-002',
    explanation:
      'Bij "ik" gebruik je alleen het grondwoord. Het grondwoord van vinden is: vind.',
    distractorExplanations: {
      '1': 'Je schreef grondwoord + t. Maar dat doe je bij hij/zij, niet bij "ik"!',
      '2': 'Je schrijft wat je hoort. Maar het grondwoord van vinden eindigt op een d.',
      '3': 'Dit woord bestaat niet.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Ik-vorm',
        content:
          'Bij "ik" gebruik je ALLEEN het grondwoord. Ik vind, ik loop, ik maak.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-001': {
    id: 'WW-L2-001',
    explanation:
      "Het grondwoord is fiets. De S zit in 't kofschip (t-k-o-f-s-ch-p). Dus schrijf je -ten.",
    distractorExplanations: {
      '1': "Dubbel T is niet nodig. Onthoud 't kofschip: t-k-o-f-s-ch-p. De S zit erin!",
      '2': 'Dit is nu (tegenwoordige tijd). Maar de zin zegt "gisteren".',
      '3': 'Dit is enkelvoud (één kind). Maar het gaat om "de kinderen" (meervoud).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: "'t Kofschip",
        content:
          'Grondwoord eindigt op t-k-o-f-s-ch-p? Dan -te/-ten in verleden tijd. Fiets eindigt op S → fietsten',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-002': {
    id: 'WW-L2-002',
    explanation:
      'Instinker! Als "jij" ACHTER het werkwoord staat, gaat de T weg. Loop jij? ✅',
    distractorExplanations: {
      '1': 'Normaal is het "jij loopt", maar als "jij" erachter staat, gaat de T weg!',
      '2': 'Dit woord bestaat niet.',
      '3': 'Dit is verleden tijd. Maar de vraag gaat over nu.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Jij/Je Omkering',
        content:
          'Jij staat ACHTER het werkwoord? Dan gaat de T weg. Loop jij? Werk je?',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-003': {
    id: 'WW-L2-003',
    explanation:
      'Het onderwerp is "het licht" = het. Bij het/hij/zij: grondwoord + t. Brand + t = Brandt.',
    distractorExplanations: {
      '1': 'Je vergeet de t. Bij "het licht" schrijf je: grondwoord + t.',
      '2': 'Dit woord bestaat niet.',
      '3': 'Dit is verleden tijd (het brandde). Maar de vraag gaat over nu.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Het/Hij/Zij',
        content:
          'Bij het, hij, zij: grondwoord + t. Het licht = het → brand + t = brandt',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-001': {
    id: 'WW-L3-001',
    explanation:
      "Heb-vorm van redden. Check 't kofschip (t-k-o-f-s-ch-p): D zit er NIET in. Dus schrijf je -d.",
    distractorExplanations: {
      '1': 'Een heb-vorm eindigt bijna nooit op -dt.',
      '2': 'Dit gebruik je alleen als bijvoeglijk naamwoord (de geredde kat).',
      '3': 'Dit is verleden tijd (redde), niet de heb-vorm.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Heb-vorm (Voltooid Deelwoord)',
        content:
          "Grondwoord eindigt NIET op 't kofschip? Dan -d. Red → heeft gered",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-002': {
    id: 'WW-L3-002',
    explanation:
      'Onderwerp = "de taart" (hij). Bij hij/zij/het: grondwoord + t. Word + t = wordt.',
    distractorExplanations: {
      '1': 'Je vergeet de t. Bij hij/zij/het schrijf je altijd: grondwoord + t.',
      '2': 'Het grondwoord "word" eindigt al op d. Dus word + t = wordt (met dt!).',
      '3': 'Dit is meervoud verleden tijd. Maar "de taart" is enkelvoud.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Worden Spelling',
        content:
          'Grondwoord van worden = "word" (eindigt op d). Bij hij/zij/het: word + t = wordt',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-003': {
    id: 'WW-L3-003',
    explanation:
      "Verleden tijd van gebeuren. Grondwoord = gebeur. R zit NIET in 't kofschip, dus -de.",
    distractorExplanations: {
      '1': 'Het onderwerp is "Het" (enkelvoud), dus geen -en.',
      '2': 'Dit is nu (tegenwoordige tijd). Maar er staat "gisteren".',
      '3': 'Dit is de heb-vorm. Maar dit is gewoon verleden tijd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Verleden Tijd',
        content:
          "Grondwoord eindigt NIET op 't kofschip? Dan -de/-den. Gebeur → gebeurde",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-003': {
    id: 'WW-L1-003',
    explanation:
      'Het onderwerp is "Zij" (één persoon). Bij hij/zij: grondwoord + t. Maak + t = maakt.',
    distractorExplanations: {
      '1': 'Dit is het hele werkwoord. Maar "zij" is hier één persoon, dus grondwoord + t.',
      '2': 'Dit is de ik-vorm (alleen grondwoord). Maar hier is het "zij".',
      '3': 'Werkwoorden eindigen nooit op -d als het grondwoord dat niet doet.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Grondwoord + t',
        content: 'Bij hij/zij/het: grondwoord + t. Zij maakt.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-004': {
    id: 'WW-L1-004',
    explanation:
      'Het onderwerp is "Jij" en staat ervoor. Dus grondwoord + t. Werk + t = werkt.',
    distractorExplanations: {
      '1': 'Alleen het grondwoord gebruik je als "jij" erachter staat (werk jij?) of bij "ik".',
      '2': 'Dit is verleden tijd. Maar er staat "vandaag".',
      '3': 'Werkwoorden eindigen nooit op -d als het grondwoord dat niet doet.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Jij + werkwoord',
        content: 'Jij staat ervoor? Dan grondwoord + t. Jij werkt.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-005': {
    id: 'WW-L1-005',
    explanation:
      'Mijn broer = hij. Bij hij/zij/het: grondwoord + t. Speel + t = speelt.',
    distractorExplanations: {
      '1': 'Dit is alleen het grondwoord (ik-vorm).',
      '2': 'Dit is het tegenwoordig deelwoord (spelend kind).',
      '3': 'Dit is verleden tijd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Grondwoord + t',
        content: 'Mijn broer = hij. Dus grondwoord + t. Hij speelt.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-004': {
    id: 'WW-L2-004',
    explanation:
      "Grondwoord = leer. R zit NIET in 't kofschip. Dus verleden tijd met -den.",
    distractorExplanations: {
      '1': 'Dit is enkelvoud (ik leerde). Maar "wij" is meervoud, dus -den.',
      '2': 'Dit is nu (tegenwoordige tijd). Maar er staat "gisteren".',
      '3': 'Dit is de heb-vorm (hebben geleerd).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: "Niet in 't Kofschip",
        content:
          "R zit niet in 't kofschip (t-k-o-f-s-ch-p). Dus verleden tijd met -d/-den.",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-005': {
    id: 'WW-L2-005',
    explanation:
      'Springen is een onregelmatig werkwoord. De klank verandert: springen → sprong.',
    distractorExplanations: {
      '1': 'Dit is meervoud. Maar het is één hond, dus enkelvoud.',
      '2': 'Springen is onregelmatig (geen "springde").',
      '3': 'Dit is nu (tegenwoordige tijd).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Onregelmatig Werkwoord',
        content: 'Springen verandert van klank: sprong (niet springde).',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-006': {
    id: 'WW-L2-006',
    explanation:
      'Jullie is meervoud. Bij meervoud gebruik je het hele werkwoord: komen.',
    distractorExplanations: {
      '1': 'Dit gebruik je bij "u" of hij/zij.',
      '2': 'Dit is verleden tijd enkelvoud.',
      '3': 'Dit is de heb-vorm (hebben gekomen).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Meervoud',
        content: 'Jullie = meervoud. Dus hele werkwoord: komen.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-004': {
    id: 'WW-L3-004',
    explanation:
      'Laten is een onregelmatig werkwoord. De heb-vorm is: gelaten.',
    distractorExplanations: {
      '1': 'Dit woord bestaat niet.',
      '2': 'Dit is het grondwoord.',
      '3': 'Dit is verleden tijd (liet), niet de heb-vorm.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Onregelmatig Werkwoord',
        content: 'Laten is onregelmatig: heeft gelaten.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-005': {
    id: 'WW-L3-005',
    explanation:
      "Grondwoord = eindig. G zit NIET in 't kofschip. Dus heb-vorm met -d: geëindigd.",
    distractorExplanations: {
      '1': 'Je schrijft een d, geen t. (Test: geëindig-de klinkt goed).',
      '2': 'Dit is verleden tijd (eindigde), niet de heb-vorm.',
      '3': 'Dit is nu (tegenwoordige tijd).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Heb-vorm (Voltooid Deelwoord)',
        content: "Geen 't kofschip letter? Dan -d. Heeft geëindigd.",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-006': {
    id: 'WW-L3-006',
    explanation:
      'Worden is een onregelmatig werkwoord. Verleden tijd enkelvoud: werd.',
    distractorExplanations: {
      '1': 'Dit is nu (tegenwoordige tijd).',
      '2': 'Dit is het hele werkwoord (meervoud).',
      '3': 'Dit is de heb-vorm (is geworden).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Onregelmatig Werkwoord',
        content: 'Worden verandert van klank: werd (niet wordde).',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-006': {
    id: 'WW-L1-006',
    explanation:
      'Hij = hij/zij. Bij hij/zij schrijf je: grondwoord + t. Fiets + t = fietst.',
    distractorExplanations: {
      '1': 'Dit is alleen het grondwoord (ik-vorm). Maar hier is het "hij".',
      '2': 'Dubbel T is niet nodig. Gewoon grondwoord + t.',
      '3': 'Je hoort een d, maar schrijf gewoon een t. Bij hij/zij altijd: grondwoord + t.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Grondwoord + t',
        content: 'Bij hij/zij/het: grondwoord + t. Hij fietst.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-007': {
    id: 'WW-L1-007',
    explanation:
      'De zon = hij/zij. Bij hij/zij schrijf je: grondwoord + t. Schijn + t = schijnt.',
    distractorExplanations: {
      '1': 'Dit is alleen het grondwoord (ik-vorm). Maar "de zon" = hij.',
      '2': 'Je schreef "schijndt". Dat is te veel! Het is gewoon "schijnt" (alleen een t).',
      '3': 'Dit is verleden tijd. Maar de vraag gaat over nu.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Grondwoord + t',
        content: 'Bij hij/zij/het: grondwoord + t. De zon schijnt.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L1-008': {
    id: 'WW-L1-008',
    explanation:
      'Wij is meervoud. Bij meervoud gebruik je het hele werkwoord: lopen.',
    distractorExplanations: {
      '1': 'Dit is de ik-vorm (alleen grondwoord). Maar "wij" is meervoud!',
      '2': 'Dit gebruik je bij hij/zij (grondwoord + t). Maar "wij" is meervoud.',
      '3': 'Dit is verleden tijd. Maar de vraag gaat over nu.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Meervoud',
        content: 'Wij/jullie/zij (meervoud) = hele werkwoord. Wij lopen.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-007': {
    id: 'WW-L2-007',
    explanation:
      "Grondwoord = werk. K zit in 't kofschip (t-k-o-f-s-ch-p). Dus verleden tijd met -te.",
    distractorExplanations: {
      '1': 'Dit is meervoud (wij werkten). Maar "de man" is enkelvoud, dus -te.',
      '2': 'Dit is nu (tegenwoordige tijd). Maar er staat "in de tuin" (verleden tijd context).',
      '3': 'Dit is de heb-vorm (heeft gewerkt). Maar dit is gewoon verleden tijd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: "'t Kofschip",
        content:
          "Grondwoord eindigt op 't kofschip letter? Dan -te/-ten in verleden tijd. Werk eindigt op K → werkte",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-008': {
    id: 'WW-L2-008',
    explanation:
      "Grondwoord = maak. K zit in 't kofschip. Dus verleden tijd meervoud met -ten.",
    distractorExplanations: {
      '1': 'Dit is enkelvoud (ik maakte). Maar "wij" is meervoud, dus -ten.',
      '2': 'Dit is nu (tegenwoordige tijd). Maar de vraag gaat over verleden tijd.',
      '3': 'Dit is de heb-vorm (hebben gemaakt). Maar dit is gewoon verleden tijd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: "'t Kofschip Meervoud",
        content:
          "K zit in 't kofschip. Meervoud verleden tijd: -ten. Wij maakten.",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L2-009': {
    id: 'WW-L2-009',
    explanation:
      "Grondwoord = regen. N zit NIET in 't kofschip. Dus verleden tijd met -de.",
    distractorExplanations: {
      '1': 'Dit is meervoud. Maar "het" is enkelvoud, dus -de (niet -den).',
      '2': 'Dit is nu (tegenwoordige tijd). Maar er staat "de hele dag" (verleden tijd).',
      '3': 'Dit is de heb-vorm (heeft geregend). Maar dit is gewoon verleden tijd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: "Niet in 't Kofschip",
        content:
          "N zit niet in 't kofschip (t-k-o-f-s-ch-p). Dus verleden tijd met -de. Het regende.",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-007': {
    id: 'WW-L3-007',
    explanation:
      'Schrijven is een onregelmatig werkwoord. De heb-vorm is: geschreven.',
    distractorExplanations: {
      '1': 'Dit is tegenwoordige tijd met een t. Maar dit is de heb-vorm!',
      '2': 'Dit is verleden tijd (schreef), niet de heb-vorm.',
      '3': 'Dit is het hele werkwoord. Maar bij "heb" gebruik je het voltooid deelwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Onregelmatig Werkwoord',
        content:
          'Schrijven is onregelmatig: heeft geschreven (niet geschrijft of geschrijfd).',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'WW-L3-008': {
    id: 'WW-L3-008',
    explanation: 'Eten is een onregelmatig werkwoord. De heb-vorm is: gegeten.',
    distractorExplanations: {
      '1': 'Je schreef "geëten" met trema. Maar bij eten is dat niet nodig!',
      '2': 'Dit is verleden tijd (aten), niet de heb-vorm.',
      '3': 'Dit is het hele werkwoord. Maar bij "hebben" gebruik je het voltooid deelwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Onregelmatig Werkwoord',
        content:
          'Eten is onregelmatig: hebben gegeten (niet geëten of geëtet).',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
}
